import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../bootstrap/Modal";
import Button from '../../bootstrap/Button';
import { colors, fontSizes } from '../../../helpers/constant';

const AttendanceNotice = observer(({ isOpen, setOpen, isHoliday, onOkButton }) => {
  const { t } = useTranslation();

  return (
    <Modal setIsOpen={setOpen} isOpen={isOpen} size={'lg'} isStaticBackdrop isScrollable>
      <ModalHeader setIsOpen={setOpen}>
        <ModalTitle>
          <div
            className='fw-bold'
            style={{
              color: colors.dark,
              fontSize: fontSizes.md,
            }}
          >
          {isHoliday ? t('attendance.notice.changeTitle') : t('attendance.notice.refusalTitle')}
        </div>
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className="container-fluid p-0" 
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colors.white,
          }}
        >
        <div>
          <div
            style={{
              color: colors.dark,
              fontSize: fontSizes.rg,
              whiteSpace: 'pre-wrap',
            }}
          >
            {isHoliday ? t('attendance.notice.changeDetail') : `${t('attendance.notice.refusalDetail')}\n\n${moment().format('L')}`}
          </div>
          <ModalFooter>
            <Button
              onClick={() => setOpen(false)}
              className='fw-bold'
              style={{
                flex: 1,
                backgroundColor: colors.grey,
                color: colors.white,
                fontSize: fontSizes.rg,
                border: 'none',
                borderBottomLeftRadius: 10,
                cursor: 'pointer',
              }}
            >
              {t('attendance.cancel')}
            </Button>
            <Button
              onClick={async () => {
                setOpen(false);
                onOkButton?.();
              }}
              className='fw-bold'
              style={{
                flex: 1,
                backgroundColor: colors.primary,
                color: colors.white,
                fontSize: fontSizes.rg,
                border: 'none',
                borderBottomRightRadius: 10,
                cursor: 'pointer',
              }}
            >
              {t('attendance.confirm')}
            </Button>
          </ModalFooter>
        </div>
      </div>
      </ModalBody>
    </Modal>
  )
});

export default AttendanceNotice;